import React, { useState } from "react";
import {
  Box,
  Button,
  CssBaseline,
  Grid,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTheme as themeStyles } from "@mui/material/styles";

import Sidebar from "../../../../components/sidebar/Sidebar";
import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import { useField } from "../../../../helpers/hooks/custom/useField";
import ListCompanyScreen from "./ListCompanyScreen";
import { CreateCompanyUseCase } from "../../../domain/CreateCompanyUseCase";
import SnackBar from "../../../../components/snackbar/SnackBar";

const CreateCompanyScreen = () => {
  const theme = useTheme();
  const themeSidebar = themeStyles();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));

  const name = useField({ type: "text", name: "name" });
  const address = useField({ type: "text", name: "address" });

  const [messageSnk, setMessageSnk] = useState("");
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const vertical = "top";
  const horizontal = "center";

  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  const handleCreateCompany = async () => {
    const resp = await CreateCompanyUseCase(name.value, address.value);
    console.log(resp);
    if (resp.message === "success") {
      snackBarDialog("EMPRESA CREADA");
    } else {
      snackBarDialog("ERROR", "error");
    }
  };

  return (
    <>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            m={5}
          >
            <Header title={"CREAR UNA COMPAÑIA"} subtitle="" />
          </Box>
          <Box m={5}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={5} textAlign="center">
                <TextField
                  {...name}
                  variant="outlined"
                  label={"NOMBRE DE LA COMPANIA"}
                  color="success"
                  fullWidth
                  sx={{ fontWeight: "bold" }}
                />
              </Grid>

              <Grid item xs={12} md={5} textAlign="center">
                <TextField
                  {...address}
                  variant="outlined"
                  label={"DIRECCION"}
                  color="success"
                  fullWidth
                  sx={{ fontWeight: "bold" }}
                />
              </Grid>

              <Grid item xs={12} md={2} textAlign="center">
                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  sx={{ height: 50 }}
                  onClick={handleCreateCompany}
                >
                  GUARDAR
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box m={5}>
            <ListCompanyScreen />
          </Box>
        </main>
      </div>
      <SnackBar
        stateSnk={stateSnk}
        vertical={vertical}
        horizontal={horizontal}
        duration={4000}
        handleClose={handleSnkClose}
        severity={severity}
        messageSnk={messageSnk}
      />
    </>
  );
};

export default CreateCompanyScreen;
